module.exports = __webpack_public_path__ + "img/banner-1.5453115d.png";